<div class="d-flex flex-column vh-100">
  <app-navbar></app-navbar>
  <div class="content flex-grow-1 d-flex justify-content-center">
    <div class="verify-email-wrapper text-center mt-5">


      <!-- Loading state -->
      @if (state === 'loading') {
        <ix-spinner size="large" class="mb-4"></ix-spinner>
        <ix-typography format="h2">{{
          'verify_email.pending.header' | translate
        }}</ix-typography>
        <ix-typography class="mt-2" format="body">{{
          'verify_email.pending.description' | translate
        }}</ix-typography>
      }

      <!-- Success state -->
      @if (state === 'success') {
        <ix-icon
          class="mb-4 success-icon"
          name="success"
          size="32"
          color="color-success"
        ></ix-icon>
        <ix-typography format="h2" class="mb-2">{{
          'verify_email.success.header' | translate
        }}</ix-typography>
        <ix-typography class="mb-4" format="body">{{
          'verify_email.success.description' | translate
        }}</ix-typography>
        <ix-button [routerLink]="'/login'" variant="primary">{{
          'general.login' | translate
        }}</ix-button>
      }

      <!-- Error state -->
      @if (state === 'error') {
        <ix-icon
          class="mb-4 error-icon"
          name="error"
          size="32"
          color="color-alarm"
        ></ix-icon>
        <ix-typography format="h2" class="mb-2">{{
          'verify_email.error.header' | translate
        }}</ix-typography>
        <ix-typography class="mb-4" format="body">{{
          'verify_email.error.description' | translate
        }}</ix-typography>
        <ix-typography format="body">
          {{ 'verify_email.error.need_help' | translate }}
          <a [href]="'links.contact_link' | translate" target="_blank">{{
            'verify_email.error.contact_us' | translate
          }}</a>
        </ix-typography>
      }

    </div>
  </div>
  <app-footer></app-footer>
</div>

